<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/SLP9Qc/tc-custom/9780830864812.jpg?1696025261804" alt="This image is the cover for the book An Introduction to Biblical Ethics"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">An Introduction to Biblical Ethics
      </h1>
      <p class="bookDescription body article font2">
        <p>What should we do or not do? What attitudes, behavior and qualities are good? Can we be good without God? What is the highest good, the purpose of human existence? These are the questions the study of ethics seeks to answer. Unlike many approaches to ethics, this book foundationally turns to Scripture, going only as far as Scripture itself goes. The result is an overview of biblical ethics that not only addresses the life of love and wisdom to be lived out by Christians as virtuous individuals, but also as Christians in community, in society and in a world of God?s creation. Key preliminary considerations of love, law, sin and virtue are given their due in this thoroughly revised and updated text. The bulk of the work is then organized around the Ten Commandments and ethical themes springing from them—loving God (commandments 1-4) and loving others (commandments 6-10). This new edition includes added material on</p>  ethical alternatives such as relativism, social contract, utilitarianism and evolutionary ethics the seven deadly sins as well as the cardinal virtues vs. theological virtues end-of-life ethics, stem-cell research, animal rights, sexuality, genetics and technology, and other bioethical issues such as plastic surgery and surrogate motherhood technology and its depersonalizing effects as well as helping the poor the church?s engagement in society and how Christians can make a difference in the media.  <p>McQuilkin and Copan stay focused on how we are fulfilling the purposes of God for our lives—a will that is for our good and our well-being. This comprehensive study is the place to begin on the journey of living wisely, faithfully and obediently.</p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Robertson McQuilkin, Paul Copan
      </h2>
      
      <p class="authorDescription body article"><p>Robertson McQuilkin (1928–2016) was a speaker and writer, engaging in extensive conference ministry in the United States and overseas. He served as the third president of Columbia International University for twenty-two years, and was beloved as president emeritus. Before becoming president, McQuilkin was headmaster of Ben Lippen School and a missionary in Japan. He was honored for his decades of work in Christian missions when by receiving the 2010 Lifetime of Service Award from Missio Nexus. His books include<em>Five Smooth Stones</em>, <em>Life in the Spirit</em>, and <em>Introdution to Biblical Ethics</em>.</p></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      InterVarsity Press
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?262deb8a